import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import directionForm from "./direction-form/direction-form";
import core from "../core/core.module";

let mod = angular
    .module('DirectionsControl.component', [angularUIB, directionForm, core])
    .component('directionsControl', {
        controller: ['$http', '$uibModal', 'Data', 'notifier', controller],
        template: require('./directions-control.component.html')
    });

function controller($http, $uibModal, Data, notifier) {

    let $ctrl = this;

    $ctrl.currentPage = 1;
    $ctrl.startStation = null;
    $ctrl.endStation = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get('/control-panel/directions/get-list', {
                params: {
                    currentPage: $ctrl.currentPage,
                    start_station: $ctrl.startStation ? $ctrl.startStation.code : null,
                    end_station: $ctrl.endStation ? $ctrl.endStation.code : null
                }
            })
            .then(
                function (response) {
                    $ctrl.directions = response.data.directions;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                }
            );
    };

    $ctrl.searchStations = function (fragment) {
        return Data.getStations(fragment);
    };

    $ctrl.clearFilter = function () {
        $ctrl.startStation = null;
        $ctrl.endStation = null;
        $ctrl.getList();
    };

    $ctrl.openForm = function (direction) {
        $uibModal
            .open({
                component: 'directionForm',
                resolve: {
                    direction: function () {
                        return direction;
                    }
                }
            })
            .result
            .then(function (dir) {
                if (direction) {
                    for (let i = 0; i < $ctrl.directions.length; i++) {
                        if ($ctrl.directions[i].id == direction.id) {
                            $ctrl.directions[i] = dir;
                            break;
                        }
                    }
                } else {
                    $ctrl.directions.push(dir);
                }
            });
    };

    $ctrl.destroy = function (direction, ind) {
        if (confirm('Вы действительно хотите удалить маршрут?')) {
            $http
                .post(`/control-panel/directions/${direction.id}`, {
                    _method: 'DELETE'
                })
                .then(
                    function (response) {
                        $ctrl.directions.splice(ind, 1);
                    },
                    function (error) {
                        notifier.errorResponse(error);
                    }
                )
        }
    }
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/directions-control/directions-control.component.js